export const exhaustive = (value: never) => value
